import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-simple-loading',
  templateUrl: './simple-loading.component.html',
  styleUrls: ['./simple-loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class SimpleLoadingComponent {}
